import React from 'react';
import { X } from 'lucide-react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';

export const ImageLightbox = ({ isOpen, onClose, image, title }) => {
  if (!image) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="max-w-[95vw] max-h-[95vh] p-0 bg-black border-0"
        data-testid="image-lightbox"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 p-2 bg-white/10 backdrop-blur-md hover:bg-white/20 rounded-full transition-all duration-200"
          data-testid="lightbox-close-button"
        >
          <X className="w-6 h-6 text-white" />
        </button>
        <div className="relative w-full h-full flex items-center justify-center p-4">
          <img
            src={image}
            alt={title || 'Gallery Image'}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
          />
          {title && (
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
              <h3 className="text-white text-2xl font-bold" style={{ fontFamily: 'Outfit' }}>
                {title}
              </h3>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
